import { sv, fi, nb, da } from 'date-fns/locale';

const locales = {
  1: {
    lang: sv,
    dayShort: 'EEE',
    dateShort: 'd/M',
  },
  3: {
    lang: nb,
    dayShort: 'EEE.',
    dateShort: 'dd.MM.',
  },
  11: {
    lang: da,
    dayShort: 'EEE',
    dateShort: 'd/M',
  },
  15: {
    lang: fi,
    dayShort: 'EEEEEE',
    dateShort: 'doMo',
  },
};

export default locales;
